module.exports = __webpack_public_path__ + "img/5S.5ab3d862.png";